export default __webpack_public_path__ + "static/media/manasvi.491a6964.png";